import React, {useEffect, useState} from "react"
import {Divider, Form} from "antd";
import TableComponent from "../../components/TableComponent";
import DocumentList from "../../components/DocumentList";
import {legalDocuments} from "../../values/legalDocuments";
import {insuranceDocuments} from "../../values/InsuraceDocument";
import SwitchComponent from "../../components/SwitchComponent";
import PrevNextButtons from "../../components/PrevNextButtons";
import {util} from "../../core/utils";
import {CalcData} from "../../model/clases/CalcData";
import {accident} from "../../values/accident";

interface StepTwoProps {
  calcData: CalcData;
  current:number
  steps:number
  initial: CalcData
  price: number
  prev():void
  next():void
  onFinish(value:any):void
  data:any;
}


const StepTwoComponent = ({prev, current, steps, onFinish,  price, data, calcData, initial }:StepTwoProps) => {
  const [premium, setPremium] = useState<number>(price);
  let riskData = [
    {
      risk: "Osiguranje odgovornosti prema trćim licima",
      insuredSum: "50000",
      premium: "35.15",
    }, ...accident[calcData.accident].values
  ];
  useEffect(()=>{
    util.screen.renderOnTop();
    setPremium(price);
  },[current, price,  initial]);
  const newRiskData = [...riskData, {
    risk: "Kasko osiguarnje mikro prevoznog sredstva",
    insuredSum: initial.itemValue!,
    premium: "35.15",
  }]
  riskData = initial.hull ? newRiskData : riskData;

  const columnsInsurance = [
    {
      title: 'Rizik',
      dataIndex: 'risk',
      key: (rec: any) => {
        return rec
      },

    }, {
      title: "Suma osiguranja",
      dataIndex: "insuredSum",
      render: (rec: any) => <div style={{textAlign: "right"}}>{`${rec} EUR`}</div>,
      key: (rec: any) => {
        return rec
      },

    }];

  return (
    <>
      <h1>Informativni obračun</h1>
      <div className={"step-two-white"}>
        <div className={"max-width-medium"}>
          <div className={"totalValue"}>
            <p>Premija sa porezom</p>
            <p className={"value"} style={{marginBottom: 0}}>{
              `${premium} EUR`
            }</p>
          </div>
        </div>
        <Divider/>
        <div className={"max-width-max"}>
          <h3 className={"uppercase"}>Izabrano osiguranje</h3>
          <TableComponent
            columns={columnsInsurance}
            dataSource={riskData}
            tableLayout={"auto"}
            showHeader={true}
          />
        </div>
      </div>
      <div className={"dark-background"}>
        <h2 className={"white-h2"}>Uslovi osiguranja</h2>
        <div>Za pregled dokumenata preporučujemo <a href={"https://get.adobe.com/reader/"} target={"_blank"}
                                                    rel={"noreferrer"}> Adobe
          Acrobat Reader.</a></div>
        <div className={"documentListGroup"}>
          <DocumentList
            title={"uslovi osiguranja"}
            data={insuranceDocuments}
          />
          <DocumentList
            title={"ostali dokumenti"}
            data={legalDocuments}/>
        </div>
        <Form
          style={{width:"100%"}}
          onFinish={onFinish}
          scrollToFirstError={true}
        >
        <SwitchComponent
          name={"terms"}
          label={"Slažem se sa uslovima osiguranja"}
          offHandleColor={"#ED2939"}
          color={"#ffffff"}
          required
          message = {"Za sklapanje osiguranja je potrebno prihvatiti uslove"}
          labelStyle={{color:"white"}}
        />
        <PrevNextButtons current={current} steps={steps} prev={()=>prev()} next/>
        </Form>
      </div>
    </>
  )
};

export default StepTwoComponent;
